// AUPREA — Catalogue des dossiers du coffre-fort (Iter 13)
// Version JavaScript miroir de /app/backend/coffre_folders.py
// Toute modification doit être répliquée dans le fichier Python.

export const COFFRE_FOLDERS = [
  {
    id: "identite_famille",
    label: "Identité & Famille",
    icon: "Users",
    subcategories: [
      { id: "livret_famille", label: "Livret de famille", essential: true },
      { id: "piece_identite", label: "Pièce d'identité / passeport", essential: false },
      { id: "acte_naissance", label: "Actes de naissance", essential: false },
      { id: "acte_mariage", label: "Actes de mariage", essential: false },
      { id: "contrat_mariage", label: "Contrat de mariage", essential: false },
      { id: "jugement_divorce", label: "Jugement de divorce", essential: false },
      { id: "pacs", label: "Convention de PACS", essential: false },
    ],
  },
  {
    id: "patrimoine_immobilier",
    label: "Patrimoine immobilier",
    icon: "Home",
    subcategories: [
      { id: "titre_propriete", label: "Titres de propriété", essential: true },
      { id: "permis_construire", label: "Permis de construire", essential: false },
      { id: "plan_cadastral", label: "Plan cadastral", essential: false },
      { id: "diagnostics", label: "Diagnostics techniques (DPE, amiante, électricité)", essential: false },
      { id: "taxe_fonciere", label: "Taxe foncière", essential: false },
      { id: "reglement_copro", label: "Règlement de copropriété", essential: false },
      { id: "assurance_habitation", label: "Attestations d'assurance habitation", essential: false },
    ],
  },
  {
    id: "patrimoine_financier",
    label: "Patrimoine financier",
    icon: "TrendingUp",
    subcategories: [
      { id: "releves_comptes", label: "Relevés de comptes", essential: false },
      { id: "contrats_epargne", label: "Contrats d'épargne (Livret A, PEL, LDDS...)", essential: false },
      { id: "assurance_vie", label: "Contrats d'assurance-vie et avenants clause bénéficiaire", essential: true },
      { id: "portefeuille_titres", label: "Relevés de portefeuille titres / PEA", essential: false },
      { id: "attestations_scpi", label: "Attestations SCPI", essential: false },
      { id: "contrats_placement", label: "Contrats de placement", essential: false },
    ],
  },
  {
    id: "dettes_engagements",
    label: "Dettes & engagements",
    icon: "AlertCircle",
    subcategories: [
      { id: "offre_pret", label: "Offres de prêt", essential: false },
      { id: "tableau_amortissement", label: "Tableaux d'amortissement", essential: false },
      { id: "assurance_emprunteur", label: "Contrats d'assurance emprunteur", essential: false },
      { id: "attestation_solde", label: "Attestations de solde", essential: false },
    ],
  },
  {
    id: "prevoyance_retraite",
    label: "Prévoyance & retraite",
    icon: "Shield",
    subcategories: [
      { id: "releve_carriere", label: "Relevés de carrière", essential: false },
      { id: "prevoyance", label: "Contrats de prévoyance / complémentaire santé", essential: false },
      { id: "retraite_per_madelin", label: "Contrats retraite (PER, Madelin)", essential: false },
    ],
  },
  {
    id: "fiscalite",
    label: "Fiscalité",
    icon: "FileText",
    subcategories: [
      { id: "avis_impot", label: "Avis d'imposition sur le revenu", essential: false },
      { id: "avis_ifi", label: "Avis IFI (le cas échéant)", essential: false },
    ],
  },
  {
    id: "volontes_protection",
    label: "Dernières volontés & protection juridique",
    icon: "Feather",
    subcategories: [
      { id: "testament", label: "Testament", essential: true },
      { id: "mandat_protection", label: "Mandat de protection future", essential: false },
      { id: "contrat_obseques", label: "Contrat obsèques", essential: false },
      { id: "donations", label: "Donations", essential: false },
      { id: "procurations", label: "Procurations", essential: false },
    ],
  },
  {
    id: "patrimoine_numerique",
    label: "Patrimoine numérique",
    icon: "Cloud",
    warning: "Ne jamais stocker d'identifiants, mots de passe ou clés privées crypto en clair dans le coffre-fort. Uniquement des pointeurs vers votre gestionnaire de mots de passe.",
    subcategories: [
      { id: "liste_comptes", label: "Liste des comptes en ligne", essential: false },
      { id: "pointeur_gestionnaire", label: "Référence du gestionnaire de mots de passe", essential: false },
    ],
  },
  {
    id: "non_classes",
    label: "Non classés",
    icon: "Inbox",
    special: true,
    subcategories: [
      { id: "autre", label: "À classer", essential: false },
    ],
  },
];

export const FOLDER_BY_ID = Object.fromEntries(COFFRE_FOLDERS.map((f) => [f.id, f]));

export function subcategoryLabel(folderId, subcategoryId) {
  const f = FOLDER_BY_ID[folderId];
  if (!f) return subcategoryId || "";
  const sc = f.subcategories.find((s) => s.id === subcategoryId);
  return sc ? sc.label : (subcategoryId || "");
}
